export const getCleanBlockType = (blockType: string): string =>
  blockType.replace(/.*_/, '');
